const newResource = {
  _id: '',
  fee: false,
  onCampus: '',
  description: '',
  tags: [],
  url: '',
  'non-BU': '',
  p: [],
  phone: '',
  imgName: '',
  done: false,
  contactName: '',
  address: '',
  buOffice: '',
  email: '',
  forStudents: '',
  name: '',
  notes: '',
};

export default function resourceEditorReducer(state, action) {
  switch (action.type) {
    case 'OPEN_RESOURCE_EDITOR':
      return {
        ...state,
        resourceEditor: {
          open: true,
          resource: action.resource || newResource,
          isNew: !action.resource,
        },
      };
    case 'CLOSE_RESOURCE_EDITOR':
      return {
        ...state,
        resourceEditor: {
          open: false,
          resource: undefined,
          isNew: undefined,
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/resourceEditor.js